import Selection from '../../../../../../core-lib/js/Selection/Selection';
import Ajax from '../core/Ajax';

export default class TicketForm {

	constructor(el) {
		this.el = el;
		this.form = this.el.querySelector('.ticket-form__form');
		this.errorBox = this.form.querySelector('.form__group--errors');
		this.country = this.form.querySelector('#country');
		this.city = new Selection('#city', this.form);
		this.state = new Selection('#state', this.form);
		this.photo = this.form.querySelector('input[name="photo"]');
		this.dob_year = new Selection('#dob_year', this.form);
		this.dob_month = new Selection('#dob_month', this.form);
		this.dob_day = new Selection('#dob_day', this.form);
		this.submitBtn = this.form.querySelector('.form__button--submit');
		this.success = this.el.querySelector('.ticket-form__success');
		this.submitted = false;

		this.onChangeCountry = this.onChangeCountry.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onResponse = this.onResponse.bind(this);

		this.country.addEventListener('change', this.onChangeCountry);
		this.form.addEventListener('submit', this.onSubmit);

		this.originalSubmitButtonText = this.submitBtn.innerHTML;
	}

	onChangeCountry(e) {
		if (e.target.value == 'US') {
			// this.city.get(0).required = true;
			this.state.get(0).required = true;
			// this.city.parent('.form__group').removeClass('form__group--hidden');
			this.state.parent('.form__group').removeClass('form__group--hidden');
		} else {
			// this.city.get(0).required = false;
			this.state.get(0).required = false;
			// this.city.parent('.form__group').addClass('form__group--hidden');
			this.state.parent('.form__group').addClass('form__group--hidden');
		}
	}

	onSubmit(e) {
		e.preventDefault();

		if (this.submitted) {
			return;
		} else if (['harrickbeamon@yahoo.com'].includes(this.form.querySelector('input[name="email"]').value)) {
			this.onResponse({
				ok: true,
				response: {
					success: true
				},
			});

			return;
		}

		this.hideErrors();

		if (!this.validateBirthdate()) {
			this.showErrors(['You must be at least 18 years old.']);
		} else if (this.photo.files.length && this.photo.files[0].size > 2 * 1024 * 1024) {
			this.showErrors(['Photo is too large.']);
		} else {
			this.submitBtn.classList.add('form__button--disabled');
			this.submitBtn.innerHTML = 'Submitting...';
			this.submitted = true;

			new Ajax({
				method: 'POST',
				form: this.form,
				params: {
					action: 'ajax_request_ticket'
				},
				callback: this.onResponse
			});
		}
	}

	validateBirthdate() {
		const minAge = 18;

		try {
			const year = parseInt(this.dob_year.get(0).value);
			const month = parseInt(this.dob_month.get(0).value);
			const day = parseInt(this.dob_day.get(0).value);

			if (!year || !month || !day) {
				return false;
			}

			const now = new Date();
			
			// Normalize to midnight for accurate comparison
			now.setHours(0, 0, 0, 0);
			
			const dob = new Date(year, month - 1, day);

			const ageDiff = now.getFullYear() - dob.getFullYear();
			const isBirthdayPassedThisYear = now.getMonth() > dob.getMonth() || (now.getMonth() === dob.getMonth() && now.getDate() >= dob.getDate());

			return ageDiff > minAge || (ageDiff === minAge && isBirthdayPassedThisYear);
		} catch (error) {
			console.error('Error validating birthdate:', error);

			return false;
		}
	}

	onResponse(ajax) {
		if (ajax.ok && ajax.response.success) {
			this.form.style.height = `${this.form.scrollHeight}px`;
			this.success.style.height = `${this.success.scrollHeight}px`;

			setTimeout(() => {
				this.form.classList.toggle('ticket-form__form--hidden');
				this.success.classList.remove('ticket-form__success--hidden');
				vb.scroll.to(this.el, 1200, -100);
			}, 300);

			setTimeout(() => {
				this.success.style.height = null;
			}, 1000);
		} else {
			this.showErrors(ajax.response.errors);
		}
	}

	showErrors(errors) {
		if (errors && Object.keys(errors).length > 0) {
			for (let key in errors) {
				const p = document.createElement('p');
				p.innerHTML = errors[key];
				this.errorBox.appendChild(p);
			}
		} else {
			const p = document.createElement('p');
			p.innerHTML = 'Could not submit your ticket request, please try again.';
			this.errorBox.appendChild(p);
		}

		this.errorBox.classList.add('visible');

		this.submitBtn.classList.remove('form__button--disabled');
		this.submitBtn.innerHTML = this.originalSubmitButtonText;

		this.submitted = false;

		vb.scroll.to(this.el, 1200);
	}

	hideErrors() {
		this.errorBox.classList.remove('visible');
		this.errorBox.innerHTML = '';
	}

}
